module.exports = __webpack_public_path__ + "static/media/group.2713ee63.svg";